import React, { Component } from 'react';
import { Table, Icon, Popover, message } from 'antd';
import moment from 'moment';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const DateFormat = 'YYYY-MM-DD';

class CRCWeeklyTable extends Component {
    state = {
        workTypes: this.props.dataList,
        content: '',
    };
    componentDidMount() {
        this.queryInvestigationStageByInvId();
    }
    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }


    getColumns = () => {
        const { userId, siteUserName, showNextWeekPlan, beginWeek, finishDate } = this.props;
        const { curRole, userId: sUserId } = sessionStorage;
        const isShow = curRole == 'CRC' && sUserId == userId && (finishDate ? moment(beginWeek).week() >= moment(finishDate).week() : true);
        return [{
            title: siteUserName,
            children: [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 85,
            }, {
                title: '工作类型',
                dataIndex: 'enterpriseWorkNameValue',
                key: 'enterpriseWorkNameValue',
                width: 100,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计') {
                        obj.props.colSpan = 9;
                    } else if (row.index == '本周备注') {
                        obj.props.colSpan = 9;
                        obj.children = (
                            <span>
                                <span>{obj.children}</span>
                                {
                                    isShow &&
                                    <Icon
                                        type="edit"
                                        style={{ fontSize: 16, color: '#008dff', float: 'right', cursor: 'pointer' }}
                                        onClick={()=>this.canEditByInvStatus(() => showNextWeekPlan({userId, enterpriseWorkNameValue: row.enterpriseWorkNameValue, type: 'comment'}))}
                                    />
                                }
                            </span>
                        );
                    }  else if (row.index == '下周计划') {
                        obj.props.colSpan = 9;
                        obj.children = (
                            <span>
                                <span>{obj.children}</span>
                                {
                                    isShow &&
                                    <Icon
                                        type="edit"
                                        style={{ fontSize: 16, color: '#008dff',float: 'right', cursor: 'pointer' }}
                                        onClick={()=> this.canEditByInvStatus(() => showNextWeekPlan({userId, enterpriseWorkNameValue: row.enterpriseWorkNameValue, type: 'plan'}))}
                                    />
                                }
                            </span>
                        );
                    }
                    return obj;
                }
            }, {
                title: '工作名称',
                dataIndex: 'enterpriseWorkTypeName',
                key: 'enterpriseWorkTypeName',
                width: 170,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                }
            }]
        }, {
            title: '周一',
            children: [{
                title: beginWeek.format(DateFormat),
                dataIndex: 'monDay',
                key: 'monDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.monDay.props.tip) {
                        const list = row.monDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.monDay.props.tip) {
                        const len = Math.ceil(row.monDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.monDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周二',
            children: [{
                title: moment(beginWeek).add(1, 'days').format(DateFormat),
                dataIndex: 'tuesDay',
                key: 'tuesDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.tuesDay.props.tip) {
                        const list = row.tuesDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.tuesDay.props.tip) {
                        const len = Math.ceil(row.tuesDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.tuesDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周三',
            children: [{
                title: moment(beginWeek).add(2, 'days').format(DateFormat),
                dataIndex: 'wednesday',
                key: 'wednesday',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.wednesday.props.tip) {
                        const list = row.wednesday.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.wednesday.props.tip) {
                        const len = Math.ceil(row.wednesday.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.wednesday.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周四',
            children: [{
                title: moment(beginWeek).add(3, 'days').format(DateFormat),
                dataIndex: 'thursDay',
                key: 'thursDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.thursDay.props.tip) {
                        const list = row.thursDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.thursDay.props.tip) {
                        const len = Math.ceil(row.thursDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.thursDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周五',
            children: [{
                title: moment(beginWeek).add(4, 'days').format(DateFormat),
                dataIndex: 'friday',
                key: 'friday',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.friday.props.tip) {
                        const list = row.friday.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.friday.props.tip) {
                        const len = Math.ceil(row.friday.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.friday.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周六',
            children: [{
                title: moment(beginWeek).add(5, 'days').format(DateFormat),
                dataIndex: 'saturDay',
                key: 'saturDay',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.saturDay.props.tip) {
                        const list = row.saturDay.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.saturDay.props.tip) {
                        const len = Math.ceil(row.saturDay.props.tip.length / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.saturDay.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }, {
            title: '周日',
            children: [{
                title: moment(beginWeek).add(6, 'days').format(DateFormat),
                dataIndex: 'sunday',
                key: 'sunday',
                width: 85,
                render: (value, row, index) => {
                    const obj = {
                        children: value,
                        props: {},
                    };
                    if (row.index == '总计' || row.index == '本周备注' || row.index == '下周计划') {
                        obj.props.colSpan = 0;
                    }
                    if (row.enterpriseWorkNameValue == '患者访视' && row.sunday.props.tip) {
                        const list = row.sunday.props.tip.split(';');
                        const node = list.map(item => <div>{item}</div>);
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    if (row.enterpriseWorkNameValue == '其他' && row.enterpriseWorkTypeName == '其他项目相关' && row.sunday.props.tip) {
                        const len = Math.ceil(row.sunday.props.tip / 10);
                        const node = [];
                        for (let i = 0; i < len; i++ ) {
                            node.push(<p key={i}>{row.sunday.props.tip.slice(i * 10, (i + 1) * 10)}</p>);
                        }
                        obj.children = <Popover placement="right" overlayClassName="gray-pop" content={node}>
                                            <div>
                                                <i className='pop'></i>
                                                {value}
                                            </div>
                                        </Popover>
                    }
                    return obj;
                }
            }]
        }];
    }

    getDataSource = () => {
        const sites = [];
        const { workTypes = [] } = this.props;
        if (workTypes != null && workTypes.length > 0) {
            workTypes.map((item, index) => {
                if (item.enterpriseWorkNameValue != '总计' && item.enterpriseWorkNameValue != '本周备注' && item.enterpriseWorkNameValue != '下周计划') {
                    sites.push({
                        index: index + 1,
                        enterpriseWorkNameValue: item.enterpriseWorkNameValue,
                        enterpriseWorkTypeName: item.enterpriseWorkTypeName,
                        monDay: <span tip={item.dateValues[0].manHourVisitTip ? item.dateValues[0].manHourVisitTip : item.dateValues[0].remarks}>{item.dateValues[0].dateValue}</span>,
                        tuesDay: <span tip={item.dateValues[1].manHourVisitTip  ? item.dateValues[1].manHourVisitTip : item.dateValues[1].remarks}>{item.dateValues[1].dateValue}</span>,
                        wednesday: <span tip={item.dateValues[2].manHourVisitTip  ? item.dateValues[2].manHourVisitTip : item.dateValues[2].remarks}>{item.dateValues[2].dateValue}</span>,
                        thursDay: <span tip={item.dateValues[3].manHourVisitTip  ? item.dateValues[3].manHourVisitTip : item.dateValues[3].remarks}>{item.dateValues[3].dateValue}</span>,
                        friday: <span tip={item.dateValues[4].manHourVisitTip  ? item.dateValues[4].manHourVisitTip : item.dateValues[4].remarks}>{item.dateValues[4].dateValue}</span>,
                        saturDay: <span tip={item.dateValues[5].manHourVisitTip  ? item.dateValues[5].manHourVisitTip : item.dateValues[5].remarks}>{item.dateValues[5].dateValue}</span>,
                        sunday: <span tip={item.dateValues[6].manHourVisitTip  ? item.dateValues[6].manHourVisitTip : item.dateValues[6].remarks}>{item.dateValues[6].dateValue}</span>,
                    });
                } else if (item.enterpriseWorkNameValue == '总计') {
                    sites.push({
                        index: '总计',
                        enterpriseWorkNameValue: item.totalString,
                    })
                } else if (item.enterpriseWorkNameValue == '本周备注') {
                    sites.push({
                        index: '本周备注',
                        enterpriseWorkNameValue: item.enterpriseWorkTypeName,
                    })
                } else if (item.enterpriseWorkNameValue == '下周计划') {
                    sites.push({
                        index: '下周计划',
                        enterpriseWorkNameValue: item.enterpriseWorkTypeName,
                    })
                }
            });
        } else {
            sites.push({
                index: '本周备注',
                enterpriseWorkNameValue: '',
            });
            sites.push({
                index: '下周计划',
                enterpriseWorkNameValue: '',
            });
        }
        return sites;
    };

    render () {
        const { loading } = this.props;
        return (
            <Table
                columns={this.getColumns()}
                dataSource={this.getDataSource()}
                rowKey={record => record.index}
                loading={loading}
                scroll={{x: 950}}
                style={{marginBottom: 40}}
                pagination={ false }
                className='crcWeekly'
            />
        )
    }
}

export default CRCWeeklyTable;


// WEBPACK FOOTER //
// ./src/components/sumTotal/crcWeekly/components/CRCWeeklyTable.js